import React from "react"
import { composeSx } from "../theme/composeSx"
import { Box, type BoxProps } from "@mui/material"
import { resolveViraPalette } from "../theme/resolveViraPalette"

export type AccentDotProps = BoxProps & {
  size?: number
  soft?: boolean
}

/** Small orange accent used on brand mark, CTAs, and active indicators. */
export function AccentDot({
  size = 9,
  soft = false,
  sx,
  ...rest
}: AccentDotProps) {
  return (
    <Box
      aria-hidden
      sx={composeSx((theme) => ({
        width: size,
        height: size,
        borderRadius: "50%",
        backgroundColor: soft
          ? resolveViraPalette(theme).accentSoft
          : resolveViraPalette(theme).accent,
        display: "inline-block",
        flexShrink: 0}), sx)}
      {...rest}
    />
  )
}
